import { requestBuilder } from '../../http/RequestBuilder';

interface FreeToSpendTransactionsCount {
    count: number;
}

const getFreeToSpendTransactionsCount = requestBuilder.query<
    FreeToSpendTransactionsCount,
    { minutesOffset: number }
>({
    endpoint: ({ minutesOffset }) =>
        `/api/holistic/free-to-spend/transactions/count?minutesOffset=${minutesOffset}`,
    queryKey: () => 'getFreeToSpendTransactionsCount',
    assertResponse: (data) => {
        if (data === '') {
            throw new Error(
                'Received an empty free-to-spend transactions count response',
            );
        }
    },
});

// Count of spend transactions over the last year. Used to gate the Fruitful AI
// entry point without downloading the full free-to-spend history.
export const useGetFreeToSpendTransactionsCount = (enabled = false) => {
    const minutesOffset = new Date().getTimezoneOffset();
    const { data, isLoading, isError, error } = getFreeToSpendTransactionsCount(
        { minutesOffset },
        { enabled },
    );

    return {
        data,
        isLoading,
        isError,
        error,
    };
};

export default useGetFreeToSpendTransactionsCount;
